export class HttpError extends Error {
  public stack?: string;

  constructor(
    public readonly message: string,
    public readonly response: Response,
    public readonly body: any
  ) {
    super(message);
  }
}
